import React from "react";
import { useTranslation } from "react-i18next";
import "../classes/recommendations.css";

import ItemCard from "./ItemCard";
import { sweetsData } from "../data/sweetsData";

const SweetsCardList = () => {
  const { t, i18n } = useTranslation();
  const isTelugu = i18n.resolvedLanguage === "te";
  return (
    <section id="recommendation" className="recommendation">
      <div className="title">
        <h1>{t("sweetsPage.heading")}</h1>
      </div>

      <div className="recommendationBox">
        {sweetsData.map((item) => {
          const { name, nameTe, desc, descTe, price, quantity, image } = item;
          return (
            <ItemCard
              key={name}
              name={isTelugu ? nameTe : name}
              desc={isTelugu ? descTe : desc}
              price={price}
              quantity={quantity}
              image={image}
              showBtn={false}
              showOrderCta={true}
            />
          );
        })}
      </div>
    </section>
  );
};

export default SweetsCardList;
